import React, {useState} from 'react'
import './Skills.scss'
import skills_bg from "../assets/skills_bg.png";
import skills_bg_hover from "../assets/skills_bg_hover.png";

const SkillsDisplay = (props) => {
    const [skills_Bg, set_Skills_Bg] = useState(skills_bg)

    function changeSvgColor(){
        set_Skills_Bg(skills_bg_hover)

    }

    function normal_state(){
        set_Skills_Bg(skills_bg)

    }
  return (
    <div>
        <div
        data-aos="fade-up"
          onMouseLeave={normal_state}
          onMouseEnter={changeSvgColor}
          className="skills_container d-inline-block"
        >
          <div className="skills_inner_container d-flex flex-column justify-content-center align-items-center">
            <img className="skills_bg" src={skills_Bg} alt="" />
            <img className="skills_icon" src={props.items.skills_icon} alt="" />
            <span className="text-white text-center">
              <p>{props.items.skills_text}</p>
            </span>
          </div>
        </div>
    </div>
  )
}

export default SkillsDisplay